import React from 'react';
import HexMark from './HexMark';
import styles from './PointList.module.css';

interface PointListProps {
  items: readonly string[];
  className?: string;
}

const PointList: React.FC<PointListProps> = ({ items, className }) => (
  <ul className={`${styles.list} ${className ?? ''}`.trim()}>
    {items.map((item) => (
      <li key={item} className={styles.item}>
        <HexMark size={9} node={false} color="navy" />
        {item}
      </li>
    ))}
  </ul>
);

export default PointList;
